import { render } from "./PokemonCard.vue?vue&type=template&id=09e02864&scoped=true&ts=true"
import script from "./PokemonCard.vue?vue&type=script&lang=ts"
export * from "./PokemonCard.vue?vue&type=script&lang=ts"

import "./PokemonCard.vue?vue&type=style&index=0&id=09e02864&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09e02864"]])